import React from 'react';
import { ImageTile, ResponsiveImage } from '@stitch-fix/mode-react';
import PropTypes from 'prop-types';

const EmptyBagImage = ({
  businessLine,
  navigatedFromLandingPage,
  navigatedFromPDP,
}) => {
  const imagePaths = {
    mens: {
      pdp: 'v1634059265/shop/UngatedPDP_empty_bag_m_2_1x.png',
      landingPage: 'v1634059262/shop/UngatedPDP_empty_bag_m_1_1x.png',
    },
    womens: {
      pdp: 'v1634059262/shop/UngatedPDP_empty_bag_w_3_1x.png',
      landingPage: 'v1634059264/shop/UngatedPDP_empty_bag_w_1_1x.png',
    },
    default: 'v1634059264/shop/UngatedPDP_empty_bag_w_2_2x.png',
  };

  let imagePath = imagePaths.default;

  if (businessLine in imagePaths) {
    if (navigatedFromPDP) {
      imagePath = imagePaths[businessLine].pdp;
    } else if (navigatedFromLandingPage) {
      imagePath = imagePaths[businessLine].landingPage;
    }
  }

  const cloudinaryUrl = 'https://res.cloudinary.com/stitch-fix/image/upload';

  const imageSources = {
    sm: {
      '1x': `${cloudinaryUrl}/c_scale,w_160/${imagePath}`,
      '2x': `${cloudinaryUrl}/c_scale,w_320/${imagePath}`,
    },
    md: {
      '1x': `${cloudinaryUrl}/c_scale,w_413/${imagePath}`,
      '2x': `${cloudinaryUrl}/c_scale,w_826/${imagePath}`,
    },
  };

  const props = {
    alt: `Stitch Fix ${businessLine}clothes`,
    sources: imageSources,
  };

  return (
    <ImageTile
      isFullWidth
      isLoading={false}
      size="inherited"
      destinationUrl="#"
      backgroundImage={<ResponsiveImage {...props} />}
    />
  );
};

EmptyBagImage.propTypes = {
  businessLine: PropTypes.string,
  navigatedFromPDP: PropTypes.bool.isRequired,
  navigatedFromLandingPage: PropTypes.bool.isRequired,
};

EmptyBagImage.defaultProps = {
  businessLine: null,
};

export default EmptyBagImage;
